export default __webpack_public_path__ + "static/media/Users.f010d56b.svg";